import R from 'ramda'
import {defineMessages} from 'react-intl'

import addNotification from './addNotification'

import reverseGeocode from '../api/reverseGeocode'
import searchFormChange from '../actions/searchFormChange'
import getCurrentQuery from '../utils/getCurrentQuery'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "While retrieving the address for this point of interest, an error occured, try again later", 
    defaultMessage: "While retrieving the address for this point of interest, an error occured, try again later"
  }
})
const notification = {type: "error", message: messages.message, title: messages.title} 

const onComplete = (dispatch, poiMarkerCount, latlng) => (err, geoCodeResult) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("failed to reverse geocode", err)
  }
  else {
      const query = getCurrentQuery();
      const indexOfPoi = R.findIndex(R.propEq('markerCount', poiMarkerCount))(query.pois);
      if (indexOfPoi !== -1) {
          const newPoi = {
                description: geoCodeResult.description,
                coordinates: latlng,
                isOpen: query.pois[indexOfPoi].isOpen,
                markerCount: poiMarkerCount,
                type:"",
            }
          dispatch(searchFormChange(['pois'], R.update(indexOfPoi, newPoi, query.pois)))
      }
      else {
        return console.error("Failed to replace poi from query", err)
      }
  }
}

export default (poiMarkerCount, latlng) => (dispatch, getState) => {
  reverseGeocode(latlng, onComplete(dispatch, poiMarkerCount, latlng));
}



/** WEBPACK FOOTER **
 ** ./app/actions/fetchAddressFromCoordinates.js
 **/